import React, { useState, useEffect } from 'react'
import './App.css'
import { Routes, Route } from "react-router-dom";
import Navbar from './Components/Navbar';
import CoursesMain from './CoursesFile/Courses-main.js';
import ContactSec1 from "./ContactFile/Contact-sec1";
import Section1 from './Components/section1';
import Section2 from './Components/section2.js';
import Section3 from './Components/section3.js';
import Section4 from './Components/section4.js';
import Section5 from './Components/section5.js';
import Footer from './Components/footer.js';
import Section6 from './Components/featuresImg.js';
import CiscoPage from './CoursesFile/ciscoPage.js';
import CCNAPage from './CoursesFile/CCNAPage';
import EthicalPage from './CoursesFile/EthicalPage.js';
import LinuxPage from './CoursesFile/LinuxPage.js';
import BasicCyberPage from './CoursesFile/Basic-cyber-page.js';
import AdvanceCyberPage from './CoursesFile/AD-cyber-page.js';
import AboutPage from './AboutFile/AboutPage.js';
import GalleryPage from './GalleryFile/GalleryPage';
import Popup from './Components/Popup.js'; //  popup import
import popupImg from './popup-img.jpeg';
// import FormNav from './Components/form-nav'

// ✅ Home page component with popup
const Home = () => {

  const [isPopupOpen, setPopupOpen] = useState(false);

  // ✅ Page load pe popup open hoga
  useEffect(() => {
    setPopupOpen(true);
  }, []);

  return (
    <>
      {/*  Popup */}
      <Popup 
        display="center" 
        isOpen={isPopupOpen} 
        onClose={() => setPopupOpen(false)}
      >

        <div className='popup-img'>
          <img src={popupImg} alt=''/>
          {/* <FormNav/> */}
        </div>
      </Popup>

      {/*  sections */}
      <Section1/>
      <Section2/>
      <Section3/>
      <Section4/>
      <Section5/>
      <Section6/>
      <Footer/>
    </>
  )
}

const App = () => {
  return (
    <div className='app-container'>
      <Navbar/>

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/ContactFile" element={<ContactSec1 />} />
        <Route path="/CoursesFile" element={<CoursesMain />} /> 
        <Route path="/CiscoPage" element={<CiscoPage/>} /> 
        <Route path="/CCNAPage" element={<CCNAPage/>} />  
        <Route path="/EthicalPage" element={<EthicalPage/>} /> 
        <Route path="/LinuxPage" element={<LinuxPage/>} />  
        <Route path="/BasicCyberPage" element={<BasicCyberPage/>} /> 
        <Route path="/AdvanceCyberPage" element={<AdvanceCyberPage/>} />  
        <Route path="/AboutPage" element={<AboutPage/>} />  
        <Route path="/GalleryPage" element={<GalleryPage/>} />  
      </Routes>
    </div>
  )
}

export default App;